const FireDoorIcon = ({ strokeColor = '#808080' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 795.1 795.1"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #4d4d4d; 
        }
        .cls-2 {
          stroke: gray;
          stroke-width: 50px;
        }
        .cls-2, .cls-3 {
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-3 {
          stroke: #fff;
          stroke-width: 20px;
        }
        .cls-4 {
          fill: #fdfdfd;
        }
      `}</style>
    </defs>

    <g id="Circles">
      <circle id="Grey_Bkg" data-name="Grey Bkg" className="cls-1" cx="397.55" cy="397.55" r="388.66" />
      <circle id="Grey" className="cls-2" cx="397.55" cy="397.55" r="372.55" />
      <circle id="White_Inner" data-name="White Inner" className="cls-3" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g id="Shapes">
      <g id="Firedoor">
        <path
          className="cls-4"
          d="M554.58,560.41c-11.12,10.43-23.19,17.1-39.77,15.34,17.64-14.22,32.76-29.53,38.47-51.5,5.86-22.58.58-42.91-13.36-62.1-11.24,10.61-18.46,22.74-18.86,39.68-10.37-12.4-17.4-25.44-19.34-40.26-1.74-13.27-1.49-26.85-1.56-40.29-.1-18.16-3.53-35.15-15.29-49.64-.57-.71-1.32-1.27-3.05-2.91.05,31.1-15.4,54.38-31.78,77.68-24.79,35.26-25.41,77.8-2.93,111.64,1.6,2.42,3.5,4.64,5.54,7.32-14.56-4.03-25.32-11.07-42.55-27.87,0,5.15,0,9.51,0,13.88-.02,14-.5,28.03.06,42.01.63,15.95-10.56,20.93-23.7,17.33-16.96-4.65-33.75-9.92-50.61-14.94-34.21-10.18-68.41-20.4-102.63-30.55-12.44-3.69-15.98-8.19-15.99-21.2-.02-113.32-.02-226.63,0-339.95,0-14.03,6.88-20.8,20.98-20.8,85.56,0,171.12,0,256.68,0,13.57,0,20.12,6.34,20.14,19.83.06,43.29.04,86.58-.02,129.87,0,2.98-.68,5.95-1.1,9.3-9.15-7.7-18.01-14.75-26.28-22.43-1.76-1.64-1.86-5.59-1.88-8.48-.14-30.3-.09-60.6-.12-90.91,0-1.98-.22-3.96-.37-6.44h-111.57c-.13.28-.25.55-.37.83,7.35,2.21,14.67,4.56,22.07,6.59,11.22,3.08,14.4,7.06,14.4,18.76,0,65.44,0,130.89,0,196.33v8.6c20.51-22,42.35-41.9,46.51-73.09,1.89-14.2,1.76-28.29-3.39-41.96-.76-2.03-1.28-4.15-2.18-7.12,25.51,8.82,46.19,22.53,59.92,44.99,13.48,22.07,18.01,46.37,15.98,72.65,11.52-10.22,16.84-26.93,34.04-31.33-2.67,20.3-1.63,40,7.22,58.84,3.51,7.46,6.65,15.36,8.28,23.4,5.4,26.51-1.71,49.52-21.57,68.9"
        />
        <path
          className="cls-4"
          d="M380.67,532.48V246.82c-.98-.44-1.6-.8-2.27-1-35.4-10.61-70.68-21.62-106.29-31.49-7.91-2.19-16.95-.32-25.48-.32v323.36c44.75,13.4,89.17,26.7,134.05,40.14,0-15.01,0-29.26,0-45.04Z"
        />
      </g>
    </g>
  </svg>
);

export default FireDoorIcon;